module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading,
      "is-panel": ""
    }
  }, [
    [_c('div', {
      staticClass: "latest-activity"
    }, [(_vm.projects.length > 0 && !_vm.isError) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('ui.dashboard.most_active_projects')))]), _vm._v(" "), _vm._l((_vm.projects), function(project, index) {
      return _c('div', {
        key: index,
        staticClass: "project-panel"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'project_leads',
            params: {
              id: project.project.id
            }
          },
          "tag": "div"
        }
      }, [_c('div', {
        staticClass: "project-header"
      }, [_c('h5', {
        staticClass: "truncate-text"
      }, [_vm._v(_vm._s(project.project.name))])]), _vm._v(" "), _c('div', {
        staticClass: "project-body"
      }, [_c('div', {
        staticClass: "row gutter-sm"
      }, [_c('div', {
        staticClass: "col-auto"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.kits')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.project.business_kits_count))])]), _vm._v(" "), _c('div', {
        staticClass: "col-auto"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.leads')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.leads_count))])]), _vm._v(" "), _c('div', {
        staticClass: "col-auto"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.my_leads')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.users_leads_count))])]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('p', {
        staticClass: "caption pre"
      }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.lead_sheet')))]), _vm._v(" "), _c('p', {
        staticClass: "accent truncate-text"
      }, [_vm._v(_vm._s(project.project.lead_mask.name))])])])])])], 1)
    })], 2) : (_vm.projects.length === 0 && !_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": require("../../../../../assets/project-empty.svg")
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.top_projects.empty_state')))]), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'project_new'
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.activity_list_widget.empty_state_intro')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('div', {
      staticClass: "aligner"
    }, [_c('div', {
      staticClass: "text-center empty-state"
    }, [_c('img', {
      attrs: {
        "src": require("../../../../../assets/project-empty.svg")
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "empty-state-margin"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.widget_error')))])])]) : _vm._e()])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f67b431e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/widgets/widgets/MostActiveProjectsWidget.vue
// module id = 2011
// module chunks = 0